import { render, staticRenderFns } from "./AdSide.vue?vue&type=template&id=49ac8614&scoped=true"
import script from "./AdSide.vue?vue&type=script&lang=ts"
export * from "./AdSide.vue?vue&type=script&lang=ts"
import style0 from "./AdSide.vue?vue&type=style&index=0&id=49ac8614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ac8614",
  null
  
)

export default component.exports